import React, { useEffect, useState } from 'react'
import { Button, Image, Nav } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import cn from 'classnames'

import { isiOSDevice } from '../../common/helpers/Mobile'
import DailyRembleVideo from '../DailyRembleVideo'

import RembleWordmarkWhite from '../../../assets/images/Remble_Wordmark-White.png'
import { getLMSObjectById } from 'components/common/api'

export default function DailyRemblePlaylistPublic() {
  const { dailyRembleId } = useParams()
  const isSmallScreen = useMediaQuery({ maxWidth: 767 })

  const [video, setVideo] = useState()
  const [shouldMute, setShouldMute] = useState(false)
  const [shouldShowSubtitles, setShouldShowSubtitles] = useState(false)

  /**
   * Main effect to get the daily remble videos
   */
  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    // Return early if no daily remble id
    if (!dailyRembleId) return

    // Hide footer
    const footer = document.querySelector('footer')
    if (footer) footer.style.display = 'none'

    // Get Daily Remble Videos
    async function getDailyRembleVideoAsync() {
      const result = await getLMSObjectById(dailyRembleId)

      setVideo(result)
    }

    getDailyRembleVideoAsync()
  }, [dailyRembleId])

  return (
    <>
      <div className='vh-100 w-100 bg-black'>
        <Nav
          className='w-100 position-absolute top-0 start-0 px-4 py-2 d-flex justify-content-between align-items-center'
          style={{
            zIndex: 1000,
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }}
        >
          <Nav.Item>
            <Image
              className='object-fit-cover'
              src={RembleWordmarkWhite}
              alt='Remble logo'
              width='100'
              loading='lazy'
            />
          </Nav.Item>

          <Nav.Item>
            {isSmallScreen ? (
              <a
                href={
                  isiOSDevice()
                    ? 'https://apps.apple.com/us/app/remble-relationship-health/id1597957847'
                    : 'https://play.google.com/store/apps/details?id=com.remble.android'
                }
                target='_blank'
                rel='noreferrer'
              >
                <Button className='rounded-1 text-capitalize'>open app</Button>
              </a>
            ) : (
              <Link to={'/'}>
                <Button className='rounded-1 text-capitalize'>sign up</Button>
              </Link>
            )}
          </Nav.Item>
        </Nav>

        <div
          className={cn(
            'shared-video h-100 mx-auto',
            isSmallScreen ? 'w-100' : 'w-50'
          )}
        >
          <DailyRembleVideo
            video={video}
            showBookmark={false}
            shouldMute={shouldMute}
            setShouldMute={setShouldMute}
            shouldShowSubtitles={shouldShowSubtitles}
            setShouldShowSubtitles={setShouldShowSubtitles}
          />
        </div>
      </div>
    </>
  )
}
